var map = {
	"./airplane.svg": 390,
	"./airplane2.svg": 391,
	"./avatar.svg": 224,
	"./calendar.svg": 875,
	"./calendar2.svg": 392,
	"./document.svg": 876,
	"./girl.svg": 411,
	"./letter.svg": 412,
	"./person-detail.svg": 877,
	"./persons.svg": 878,
	"./plane.svg": 879,
	"./settings.svg": 880,
	"./suit.svg": 413,
	"./wallet.svg": 414,
	"./wallet2.svg": 415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 874;